<template>
  <v-dialog v-model="value" max-width="500px"
  transition="dialog-bottom-transition" >
    <v-card class="pa-3 justify-center">
      <v-card-title  color="primary" >
        <v-row>
          <v-col cols="11">
            <span class="titulo no-word-break">INFORME DE TRAZABILIDAD DE ELEMENTO EXTRAVIADO</span>
          </v-col>
          <v-col cols="1">
            <v-btn
              icon
              x-small
              @click="onCancelar"
            >
              <v-icon large color="primary">mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text :class="`text-medium text-size-1`" style="white-space: pre-line">
        <div>
            <v-row>
              <v-col cols="12" class="text-center">
                <span class="titulo">Datos Generales</span>
              </v-col>
              <v-row class="seccion">
                <v-col cols="6">
                  <span>ID del Elemento:</span>
                  <br><br>
                  <span class="titulo">
                    {{ oModalDetalleElemento?.idElemento }}
                  </span>
                </v-col>
                <v-col cols="6">
                  <span class="titulo2">Fecha de Registro:</span>
                  <br><br>
                  <span class="black--text">{{ onMostrarFechaHora(oModalDetalleElemento?.FechaRegistro,0) }}</span>
                  
                </v-col>
                <v-col cols="12">
                  <span class="titulo2">Elemento:</span>
                  <br><br>
                  <span class="black--text">{{ oModalDetalleElemento?.elemento }}</span>
                </v-col>
                <v-col cols="12">
                  <span class="titulo2">Hora de Registro:</span>
                  <br><br>
                  <span class="black--text">{{ onMostrarFechaHora(oModalDetalleElemento?.FechaRegistro,1) }}</span>
                </v-col>
                <v-col cols="12">
                  <span class="titulo2">Pertenece a:</span>
                  <br><br>
                  <span class="black--text">{{ oModalDetalleElemento?.TipoPropietario }}</span>
                </v-col>
              </v-row>

              <v-col cols="12" class="text-center">
                <span class="titulo">Estado Actual</span>
              </v-col>

              <v-row class="seccion">
                <v-col cols="12">
                  <span class="titulo2">Estado:</span>
                  <br><br>
                  <span class="titulo">{{ oModalDetalleElemento?.Estado }}</span>
                </v-col>
                <v-col cols="12">
                  <span class="titulo2">Última Actualización:</span>
                  <br><br>
                  <span class="black--text">{{ oModalDetalleElemento?.fechaActualizacion }}</span>
                </v-col>
              </v-row>

              <v-row class="seccion">
                <v-col cols="12">
                  <span class="titulo2">Fotos del Elemento ({{ oModalDetalleElemento?.aAnexos?.length }}):</span>
                </v-col>
                <v-col cols="4" v-for="oFoto in oModalDetalleElemento?.aAnexos">
                  <img
                    :src="oFoto.anexo"
                    style="width: 100%"
                  />
                </v-col>
              </v-row>
              
              <v-col cols="12" class="text-center">
                <span class="titulo">Historial de Trazabilidad</span>
              </v-col>

              <v-row class="seccion2" v-for="oElementoEstado in oModalDetalleElemento?.aEstados">
                <v-row>
                  <v-col cols="12">
                    <span class="titulo2">{{ oElementoEstado.FechaRegistro }}</span>
                  </v-col>
                  <v-col cols="12">
                    <span class="titulo">En custodia {{ oElementoEstado.Estado }}</span>
                  </v-col>
                  <v-col cols="12">
                    <span class="titulo2">Gestor: {{ oModalDetalleElemento?.Gestor }}</span>
                  </v-col>
                  <template v-if="oElementoEstado?.idEstado==1">
                    <v-col cols="12">
                      <v-divider></v-divider>
                    </v-col>
                    <v-col cols="12">
                      <span class="titulo2">Observación Específica del Elemento:</span>
                      <br><br>
                      <span class="black--text pl-3"></span>{{ oModalDetalleElemento?.Observaciones }}
                    </v-col>
                  </template>
                </v-row>
              </v-row>


            </v-row>
          </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name:'DialogDetalleElemento',
    props: {
      oModalDetalleElemento: {
          type: Object,
          default: () => {}
      },
      value: {
        type: Boolean,
        default: false
      },
    },
    
    data() {
      return {
        timeoutId: null
      }
    },
    methods: {
      onCancelar(){
        this.$emit('onValidacionModalElemento', false)
      },
      onMostrarFechaHora(sFecha,nPosicion){
        if(sFecha!=""){
          let aFechaTemp = sFecha?.split(" ");
          if(aFechaTemp){
            return aFechaTemp[nPosicion];
          }
        }
        return sFecha;
      }
    },
    
  }
</script>

<style lang="scss" scoped>
.margin-auto{
  margin: 0 auto;
}
.titulo{
  color: #0056D3;
  font-size: medium;
}
.subtitulo{
  font-size: medium;
}
.alertInformativo{
    margin-top: 14px;
    border-radius: 10px;
    padding: 8px 12px;
    margin-bottom: 8px;
    border: 1.26px solid #1447E6;
    font-family: "Poppins";
}
.segundoEstiloImagen{
  max-height: 100%;
  max-width: 100%;
  object-fit: contain;
}
.segundoEstilo{
  border: 2px solid #b3cdf2;
  background: white;
  border-radius: 10px;
  height: 100px;
}
.titulo2{
  color:#6A7282
}
.seccion{
  background: #F9FAFB;
  margin: 10px;
}
.seccion2{
  background: #F9FAFB;
  margin-top: 14px;
  border-radius: 10px;
  padding: 8px 12px;
  margin-bottom: 8px;
  border: 1.26px solid gray;
  font-family: "Poppins";
  margin: 10px;
}
.no-word-break {
  word-break: normal;
  overflow-wrap: normal;
  white-space: normal;
}
</style>